module.exports = __webpack_public_path__ + "files/ffff12c727b8c880a10554008dfa7114.png";